import React, { useContext, useEffect, useState } from "react";
import "amazon-connect-streams";
import { Button, Dropdown } from "semantic-ui-react";
import { Card } from "semantic-ui-react";
import Alert from "@material-ui/lab/Alert";
import { getLogger } from "../services/LoggingService";
import AppContext from "../contexts/AppContextProvider";
import RestApiContext from "../contexts/RestApiContext";
interface IProps {
    dispositions: string[];
    showDispositions: boolean;
    contactId: string;
    disposition: string;
}
interface IState {
    contact?: connect.Contact;
    disposition: string;
    loading: boolean;
    buttonState: {
        text: string;
    };
    submittingDisposition: boolean;
    dispositionSubmitted: boolean;
    submittedDisposition: string;
}

const logger = getLogger("Disposition");
const defaultState = (): IState => {
    return {
        contact: undefined,
        disposition: "",
        loading: false,
        buttonState: {
            text: "Submit Disposition",
        },
        submittingDisposition: false,
        dispositionSubmitted: false,
        submittedDisposition: "",
    };
};

/**
 * This panel will be displayed below the CCP iFrame
 */
export function Disposition(props: IProps) {
    const { setAlert } = useContext(AppContext);
    const api = useContext(RestApiContext);
    const [state, setState] = useState(defaultState());

    useEffect(() => {
        if (!props.disposition) return;
        setState({
            ...state,
            submittingDisposition: false,
            submittedDisposition: props.disposition,
            disposition: "",
            dispositionSubmitted: true,
            buttonState: {
                ...state.buttonState,
                text: "Resubmit Disposition",
            },
        });
    }, [props.disposition]);
    const submitDisposition = async () => {
        logger.debug("submitDisposition clicked");

        try {
            setState({
                ...state,
                submittingDisposition: true,
                buttonState: {
                    ...state.buttonState,
                    text: "Submitting ...",
                },
            });

            const attributes = {
                disposition: state.disposition,
            };
            logger.debug("Update contact attribute query ", props.contactId, attributes);
            await api.updateContactAttributes(props.contactId, attributes);
            //check rule trigger to see if we need to do anything else with disposition
            //await api.ruleTrigger("disposition", state.disposition);
            setAlert("Success", "success");
        } catch (error) {
            setAlert(error.message, "error");
        } finally {
            setState({
                ...state,
                submittingDisposition: false,
                submittedDisposition: state.disposition,
                disposition: "",
                dispositionSubmitted: true,
                buttonState: {
                    ...state.buttonState,
                    text: "Resubmit Disposition",
                },
            });
        }
    };

    const handleChange = (event: any, data: any): void => {
        logger.debug("hello");
        setState({
            ...state,
            disposition: data.value,
        });
    };

    const getDispositionOptions = (options: string[]) => {
        return options.map((option, i) => ({
            key: `${option}-${i + 1}`,
            text: option,
            value: option,
        }));
    };

    if (!props.showDispositions) {
        return null;
    }

    const requiredMessage =
        !state.disposition && !state.dispositionSubmitted ? (
            <Alert severity={"info"}>Disposition is required.</Alert>
        ) : null;
    const submittedMessage = state.dispositionSubmitted ? (
        <Alert severity={"success"}>{`${state.submittedDisposition} submitted.`}</Alert>
    ) : null;
    return (
        <Card id="disposition-list" className="card-jmb">
            <Card.Content>
                <Card.Header className="mb-5" textAlign="left">
                    Disposition List
                </Card.Header>

                <Dropdown
                    className="mb-5"
                    clearable
                    search
                    selection
                    fluid
                    onChange={handleChange}
                    value={state.disposition}
                    options={getDispositionOptions(props.dispositions)}
                    placeholder="Select a disposition"
                />

                {requiredMessage}
                {submittedMessage}
                {state.disposition ? (
                    <Button
                        disabled={state.submittingDisposition}
                        loading={state.submittingDisposition}
                        onClick={submitDisposition}
                        className="action-button"
                    >
                        {state.buttonState.text}
                    </Button>
                ) : null}
            </Card.Content>
        </Card>
    );
}
